var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mobileSafariPWA)?_c('div',{staticClass:"c-pull",class:{ 'c-visible': _vm.showPullToRefresh }},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }